<div class="main-popup mt-4">
    <div class="main-title-popup mb-4">
        <h1>Disinfection</h1>
        <p>Details for Disinfection Instructions</p>
    </div>
    <form [formGroup]="disinfectionForm" (ngSubmit)="onSubmit()">
        <div *ngFor="let instruction of instructionKeys" class="custom-checkbox-container">
            <label class="custom-checkbox-label">
                <input
                    type="checkbox"
                    class="native-checkbox"
                    [value]="instruction.instruction" 
                    [checked]="isChecked(instruction.instruction)"
                    (change)="onCheckboxChange($event)" />
                {{ instruction.instruction }}  <!-- Display the instruction text -->
            </label>
        </div>
        <div *ngIf="disinfectionForm.get('instructions').invalid && disinfectionForm.get('instructions').touched" class="text-danger">
            Please select at least one instruction.
        </div>

        <div class="row">
            <div class="col-md-12 text-right">
                <button class="btn btn-primary" type="submit" [disabled]="isLoading$ | async">
                    <span *ngIf="!isAuthLoading">Submit</span>
                    <span *ngIf="isAuthLoading">Submitting...</span>
                </button>
                <img *ngIf="isLoading$ | async" src="assets/img/loader.gif" alt="Loading..." class="loader-image mt-2">
            </div>
        </div>
    </form>
</div>